import { resolve } from '@serko/service-resolver-browser';

export interface ResolvedUrls {
  serkoCdn: string;
  zenoCdn: string;
  webApiUrl: string;
  metricsApiUrl: string;
  robotoUrl: string;
  robotoCondensedUrl: string;
}

export async function resolveUrls(): Promise<ResolvedUrls> {
  // If we're running in a dev environment we can override the tag via .env
  const tag =
    (process.env.NODE_ENV === 'development' &&
      process.env.REACT_APP_API_RESOLVER_TAG) ||
    window.location.hostname;

  let {
    'asset.cdn.serko': { url: serkoCdn },
    'asset.cdn.zeno': { url: zenoCdn },
    'asset.zeno.font.roboto': { url: robotoUrl },
    'asset.zeno.font.robotocondensed': { url: robotoCondensedUrl },
    'api.zeno.travellerlanding.api': { url: webApiUrl },
    'api.desktop.itinerary': { url: metricsApiUrl },
  } = await resolve(
    [
      'asset.cdn.serko',
      'asset.cdn.webapp',
      'asset.cdn.zeno',
      'asset.zeno.font.roboto',
      'asset.zeno.font.robotocondensed',
      'api.zeno.travellerlanding.api',
      'api.desktop.itinerary',
    ],
    {
      domaintags: [tag],
    },
  );

  // We can also override the api url as well
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_API_URL) {
    webApiUrl = process.env.REACT_APP_API_URL;
  }

  // Ensure that the trailing slash is on the url
  const urls: ResolvedUrls = {
    serkoCdn,
    zenoCdn,
    webApiUrl,
    metricsApiUrl,
    robotoUrl,
    robotoCondensedUrl,
  };

  const formattedUrls: ResolvedUrls = Object.entries(urls).reduce(
    (previousUrls, data) => {
      const key = data[0];
      // Add trailing slash if it's missing
      const slashRegex = new RegExp('([^/])$');
      const currentUrl = (data[1] as string).replace(slashRegex, '$1/');
      return {
        ...previousUrls,
        [key]: currentUrl,
      };
    },
    {
      serkoCdn: '',
      zenoCdn: '',
      webApiUrl: '',
      metricsApiUrl: '',
      robotoUrl: '',
      robotoCondensedUrl: '',
    },
  );

  return formattedUrls;
}
